import { CloseOutlined, HelpOutline } from '@mui/icons-material'
import { Button, Card, CardContent, IconButton, Input, Link, Modal, Stack, Textarea, Tooltip, Typography } from '@mui/joy'
import React, { ReactNode } from 'react'
import useCardHelp from './utils/useCardHelp'
import { head } from 'shelljs'
import { headCardHelp } from './utils/headCardHelp'

type Props = {
  slot?:{button?:ReactNode}
}

const CardHelp = ({slot}: Props) => {

  const {
    open,
    setOpen,
    href,
    message,
    setMessage,
  } = useCardHelp({})

  return (
    <>
      <Tooltip title='Need Help?'>
        <IconButton
          variant="plain"
          color="neutral"
          onClick={() => {
            setOpen(!open)
          }}
        >
          <HelpOutline />
          {slot?.button}
        </IconButton>
      </Tooltip>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
      >
        <Stack sx={{ justifySelf: 'center', mt: '35vh' }}>
          <Card sx={{ gap: 2, maxWidth: 400, m: 'auto' }}>
            <Stack pt={2} gap={2}>
              <Typography textAlign={'center'} level="h4">💬 Need Help?</Typography>
              <Typography textAlign={'center'} level="body-sm">We're here to assist you! If you have any questions or need support, feel free to reach out to us.</Typography>
              <IconButton
                aria-label="bookmark Bahamas Islands"
                variant="plain"
                color="neutral"
                size="sm"
                sx={{ position: 'absolute', top: '0.875rem', right: '0.5rem' }}
                onClick={() => setOpen(false)}
              >
                <CloseOutlined />
              </IconButton>
            </Stack>
            <CardContent sx={{ gap: 2 }}>
              <Textarea placeholder={headCardHelp.placeholder} minRows={3} value={message} onChange={(e) => setMessage(e.target.value)} />
              <Link href={href} onClick={() => setOpen(false)} target='_blank' sx={{ width: 1 }}>
                <Button fullWidth>Send Message</Button>
              </Link>
            </CardContent>
          </Card>

        </Stack>
      </Modal>
    </>
  )
}

export default CardHelp